import { Disclosure, DisclosureContent, DisclosureProvider } from '@ariakit/react'
import { isEmpty } from 'lodash-es'
import { useMemo } from 'react'
import styled from 'styled-components'

import { FormError } from '../../../../app/_components/form/FormError'
import {
  VariantSelectionFitRadioGroup,
  useVariantSelectionFitField,
} from '../../../../app/_components/forms/VariantSelectionFitField'
import {
  VariantSelectionFieldValueDisplay,
  VariantSelectionFormFields,
} from '../../../../app/_components/forms/VariantSelectionForm'
import {
  VariantSelectionSizeRadioGroup,
  useVariantSelectionSizeField,
} from '../../../../app/_components/forms/VariantSelectionSizeField'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import {
  AccordionCarat,
  AccordionDetails,
  AccordionHeader,
  AccordionHeaderSummary,
  AccordionHeading,
  AccordionSubHeading,
  EmbroideryAccordionOption,
} from '../styles'

export const EmbroiderySizeOptions: React.FC = () => {
  const translations = useTranslation()
  const { displayValue: selectedSizeDisplayValue } = useVariantSelectionSizeField()
  const { displayValue: selectedFitDisplayValue } = useVariantSelectionFitField()

  const subHeading = useMemo(() => {
    if (isEmpty(selectedSizeDisplayValue))
      return translations.embroidery.modal.sizeVariants.sizeNotSelected

    const variationSelections: string[] = [selectedSizeDisplayValue]
    if (!isEmpty(selectedFitDisplayValue)) variationSelections.push(selectedFitDisplayValue)
    return variationSelections.join(' | ')
  }, [
    selectedFitDisplayValue,
    selectedSizeDisplayValue,
    translations.embroidery.modal.sizeVariants.sizeNotSelected,
  ])

  return (
    <li>
      <DisclosureProvider>
        <EmbroideryAccordionOption>
          <Disclosure render={htmlProps => <AccordionHeader {...htmlProps} />}>
            <AccordionHeader>
              <div>
                <AccordionHeading>{translations.quickBuy.modal.size}</AccordionHeading>
                <AccordionSubHeading>{subHeading}</AccordionSubHeading>
              </div>
              <AccordionCarat />
            </AccordionHeader>
            <AccordionHeaderSummary>
              <FormError name='size' />
              <FormError name='fit' />
            </AccordionHeaderSummary>
          </Disclosure>
          <DisclosureContent>
            <AccordionDetails>
              <VariantSelectionFormFields>
                <VariantSelectionSizeRadioGroup hideLabel />
                <EmbroideryFitRadioGroup />
              </VariantSelectionFormFields>
            </AccordionDetails>
          </DisclosureContent>
        </EmbroideryAccordionOption>
      </DisclosureProvider>
    </li>
  )
}

const EmbroideryFitRadioGroup = styled(VariantSelectionFitRadioGroup)`
  ${VariantSelectionFieldValueDisplay} {
    font-weight: ${o => o.theme.typography.font.weight[600]};
    color: ${o => o.theme.color.text.secondary.on.subtle};
  }
`
